const getHourIn12HrFormat = (hours) => {
  const session = hours >= 12 ? 'PM' : 'AM';
  let hrs = hours > 12 ? hours - 12 : hours;
  hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
  hrs = hrs < 10 ? `0${hrs}` : hrs;
  return `${hrs}${session}`;
};

const getHoursAndMins = time => {
  let date;
  if (time && time.includes('Z')) {
    date = new Date(time);
  } else {
    date = new Date(time + 'Z');
  }
  return {
    date,
    hours: date.getHours(),
    minutes: date.getMinutes(),
  };
};

const range = (start, end) => {
  return Array(end - start + 1).fill().map((_, index) => start + index);
};

export {
  getHourIn12HrFormat,
  getHoursAndMins,
  range,
};
